export const wordOne = [
  {
    id: 1,
    text: "Rule",
    response: "The First rule of driving is to pay attention.",
  },
  {
    id: 2,
    text: "Organize",
    response: "Organize thoughts before responding.",
  },
  {
    id: 3,
    text: "Talk",
    response: "Persuasive talking is an art.",
  },
  {
    id: 4,
    text: "Terror",
    response: "Indians are united against terrorism.",
  },
  {
    id: 5,
    text: "Victory",
    response: "Beyond fear lies victory.",
  },
  {
    id: 6,
    text: "War",
    response:
      "Countries need to resolve their conflicts without resorting to war.",
  },
  {
    id: 7,
    text: "Zeal",
    response: "The country is witnessing entrepreneurial zeal among youth.",
  },
  {
    id: 8,
    text: "Mature",
    response: "Experiences determine maturity more than age.",
  },
  {
    id: 9,
    text: "Guess",
    response: "Experience helps in making educated guesses.",
  },
  {
    id: 10,
    text: "Smart",
    response: "Stocks and crypto are smart investment.",
  },
  {
    id: 11,
    text: "Jog",
    response: "A morning jog lifts the spirits.",
  },
  {
    id: 12,
    text: "Earn",
    response: "Earning an uniform is a dream of every defence aspirant.",
  },
  {
    id: 13,
    text: "Forest",
    response: "Forests are the lungs of the biosphere.",
  },
  {
    id: 14,
    text: "Gold",
    response: "Olympic gold medal is a pinnacle of sporting success.",
  },
  {
    id: 15,
    text: "Group",
    response: "Group discussions open up new perspectives.",
  },
  {
    id: 16,
    text: "Habit",
    response: "Good eating habits are essential for a healthy lifestyle.",
  },
  {
    id: 17,
    text: "India",
    response: "India is filled with diversity in all aspects.",
  },
  {
    id: 18,
    text: "Kill",
    response: "Short-term procrastination kills long-term goals.",
  },
  {
    id: 19,
    text: "Lively",
    response: "Lively imagination leads to creativity.",
  },
  {
    id: 20,
    text: "Lazy",
    response: "Self-discipline fights laziness.",
  },
  {
    id: 21,
    text: "Meet",
    response: "Meeting new people helps us discover new things.",
  },
  {
    id: 22,
    text: "Demand",
    response: "A decrease in supply and a rise in demand leads to inflation.",
  },
  {
    id: 23,
    text: "Merit",
    response: "Indian Armed Forces recruits on merit alone.",
  },
  {
    id: 24,
    text: "Alcohol",
    response: "Alcohol is highly inflammable.",
  },
  {
    id: 25,
    text: "Curfew",
    response: "Many towns are placed under curfew during Covid.",
  },
  {
    id: 26,
    text: "Ignore",
    response: "Ignoring the problem makes it worse.",
  },
  {
    id: 27,
    text: "Violate",
    response: "Stealing customer data is violation of privacy.",
  },
  {
    id: 28,
    text: "Reaction",
    response: "Chemical reaction are fastened using catalysts.",
  },
  {
    id: 29,
    text: "Exercise",
    response: "INDRA is an Indian-Russian naval exercise.",
  },
  {
    id: 30,
    text: "Error",
    response: "Human errors have lead to many natural disasters.",
  },
  {
    id: 31,
    text: "Mindset",
    response: "Positive mindset leads to success.",
  },
  {
    id: 32,
    text: "Educate",
    response: "Education uplifts the society.",
  },
  {
    id: 33,
    text: "Sputnik",
    response: "Sputnik V is the first covid vaccine discovered.",
  },
  {
    id: 34,
    text: "Boast",
    response: "Never boast your accomplishments.",
  },
  {
    id: 35,
    text: "Physical",
    response: "Physical fitness leads to mental well-being.",
  },
  {
    id: 36,
    text: "Rational",
    response: "Humans are rational being.",
  },
  {
    id: 37,
    text: "Role",
    response: "Physical fitness plays essential role in preventing diseases.",
  },
  {
    id: 38,
    text: "Safari",
    response: "Africa is famous for safari.",
  },
  {
    id: 39,
    text: "Toy",
    response: "Toy story is the first animated movie released.",
  },
  {
    id: 40,
    text: "Active",
    response:
      "The younger generation is showing an active interest in politics.",
  },
  {
    id: 41,
    text: "Average",
    response: "Average thinking produces average results.",
  },
  {
    id: 42,
    text: "Mediocre",
    response: "Don't settle for mediocrity.",
  },
  {
    id: 43,
    text: "Mask",
    response: "Moon masks sun during solar eclipse.",
  },
  {
    id: 44,
    text: "Quality",
    response: "Honesty is a desirable quality.",
  },
  {
    id: 45,
    text: "Covid",
    response: "Covid has affected every aspect of mankind.",
  },
  {
    id: 46,
    text: "Common",
    response: "A team shows commonness of purpose.",
  },
  {
    id: 47,
    text: "Ancestor",
    response: "Aryans are the ancestors of Indians.",
  },
  {
    id: 48,
    text: "People",
    response: "B.R. Ambedkar was the man of people.",
  },
  {
    id: 49,
    text: "Bless",
    response: "Good health and peace of mind are blessings.",
  },
  {
    id: 50,
    text: "Appreciate",
    response: "We appreciate things more when they are scarce.",
  },
  {
    id: 51,
    text: "Found",
    response: "Traces of water is found on mars.",
  },
  {
    id: 52,
    text: "Friend",
    response: "A friend worth millions.",
  },
  {
    id: 53,
    text: "colleague",
    response: "Supportive colleague makes work easier.",
  },
  {
    id: 54,
    text: "Brother",
    response: "Defence Academies binds cadets together in brotherhood.",
  },
  {
    id: 55,
    text: "Stress",
    response: "Meditation is a great stress buster.",
  },
  {
    id: 56,
    text: "Noise",
    response: "Noise above 85db is harmful to human hearing.",
  },
  {
    id: 57,
    text: "Cheat",
    response: "Cheating is punished under IPC 420 in India",
  },
  {
    id: 58,
    text: "Spiritual",
    response: "There is a tradition of spirituality in Indian culture.",
  },
  {
    id: 59,
    text: "Sanity",
    response: "Worry undermines our sanity.",
  },
  {
    id: 60,
    text: "Sorrow",
    response: "Desiring too much leads to sorrow and greed.",
  },
];
